import { useEffect, useState } from "react";

type Props = {
  expiresInSeconds: { value: number };
  onExpiry: () => void;
};

export const useTimer = ({ expiresInSeconds, onExpiry }: Props) => {
  const [expired, setExpired] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(
    expiresInSeconds.value
  );

  useEffect(() => {
    setSecondsRemaining(expiresInSeconds.value);

    const interval = setInterval(() => {
      setSecondsRemaining((prevSeconds) => {
        if (prevSeconds <= 0) {
          clearInterval(interval);
          setExpired(true);
          onExpiry();

          return 0;
        }

        return prevSeconds - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresInSeconds]);

  return {
    secondsRemaining,
    expired,
    setExpired,
  };
};
